export default Object.freeze({
    'GET_TABLE': Symbol(),
    'GET_LIST': Symbol(),
    'DELETE': Symbol(),
    'UPDATE': Symbol(),
    'CREATE': Symbol()
});